<template>
    <div>
      <PendingLiquidations/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import PendingLiquidations from '@/components/PendingLiquidations.vue'
  
  export default {
    name: 'liquidation-approval-history-view',
    components: {
      PendingLiquidations
    }
  }
  </script>
  